import { sandboxApi } from "services/sandbox-api/api";
import { RootState } from "store";
import { CodeShareUser } from "types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AuthState, sandboxUserLoaded, setCredentials } from "./authSlice";
import { sandboxActionInvoked } from "../actions/actionsSlice";
import { actionItemsAdded } from "../header/headerSlice";

interface UserAuthenticatedAction extends Omit<AuthState, "silentSigninInProgress" | "silentSigninError"> {
};

export const userAuthenticated = createAsyncThunk(
  "auth/userAuthenticated",
  async (action: UserAuthenticatedAction, thunkApi) => {
    const state = thunkApi.getState() as RootState;

    thunkApi.dispatch(setCredentials(action));
    thunkApi.dispatch(actionItemsAdded(["create", "fork", "like", "delete", "shareIdea", "embed", "export"]));

    if (!state.auth.sandboxUser) {
      const result = thunkApi.dispatch(sandboxApi.endpoints.user.initiate());

      try {
        const sandboxUser: CodeShareUser = await result.unwrap();
        thunkApi.dispatch(sandboxUserLoaded(sandboxUser));
      } catch (error) {
        // Sandbox user is not registered yet
        thunkApi.dispatch(sandboxActionInvoked({ type: "set-username" }))
      } finally {
        result.unsubscribe();
      }
    }
  }
);